import styled from "styled-components";
import Img from "gatsby-image";
import { breakpoints } from "../../styles/variables";
import { colors } from "../../styles/variables";
import { FaPlay } from "react-icons/fa";

export const Wrapper = styled.div`
    position: relative;
    height: auto;
`;

export const SliderWrapper = styled.div`
    position: relative;
`;

export const StyledImg = styled(Img)``;

export const StyledButton = styled.button`
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    outline: none;
    border: solid 2px #fff;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    background-color: transparent;
    transition: border-color 0.3s ease, color 0.3s ease;

    &:hover {
        border-color: ${colors.primary};
        svg {
            color: ${colors.hoverRed};
        }
    }
    &:focus {
        outline: none;
    }
    font-size: 3rem;
    @media (min-width: ${breakpoints.lg}) {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const Description = styled.div`
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: -0.4rem;
    padding: 8rem 0;
    @media (min-width: ${breakpoints.md}) {
        padding: 10rem 2rem;
    }
`;
export const Date = styled.p`
    margin: 0.25rem auto 0;
    font-size: 1.125rem;
    font-weight: 500;
    @media (min-width: ${breakpoints.lg}) {
        font-size: 1.5rem;
    }
`;
export const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    // box-shadow: 0 1px 10px rgba(0, 0, 0, 0.05);
    font-size: 1.5rem;
    font-weight: 500;
    text-align: center;
    letter-spacing: 1px;
    color: ${colors.lightDark};
    max-width: 250px;
    @media (min-width: ${breakpoints.sm}) {
        max-width: 650px;
        padding: 3rem 2rem;
        font-size: 2rem;
        // box-shadow: 0 24px 48px rgba(0, 0, 0, 0.3);
    }
`;

export const Details = styled.p`
    margin: 0rem;
    font-size: 1.2rem;
    font-weight: 300;
    @media (min-width: ${breakpoints.lg}) {
        text-align: left;
    }
`;

export const Title = styled(Details)`
    font-weight: 700;
`;

export const StyledIcon = styled(FaPlay)`
    font-size: 1.7rem;
    color: #fff;
`;

export const PageTopLinearBg = styled.div`
    position: absolute;
    top: -540px;
    left: -250px;
    width: 820px;
    height: 820px;
    transform: rotate(58.618deg);
    flex-shrink: 0;
    border-radius: 820px;
    background: transparent;
    @media (max-width: ${breakpoints.sm}) {
        top: -420px;
        left: -400px;
        transform: scale(0.3);
    }
    @media (max-width: ${breakpoints.md}) {
        transform: scale(0.6);
    }
`;

export const PageBottomLinearBg = styled.div`
    position: absolute;
    bottom: 140px;
    right: -220px;
    width: 420px;
    height: 420px;
    transform: rotate(-1.382deg);
    flex-shrink: 0;
    border-radius: 420px;
    background: transparent;
    @media (max-width: ${breakpoints.sm}) {
        bottom: 10px;
        right: -250px;
        transform: scale(0.3);
    }
    @media (max-width: ${breakpoints.md}) {
        transform: scale(0.6);
    }
`;
